/**
 * Created by neo on 18.12.20.
 */
import { Pageable } from '../../Interfaces/Pageable';
import { SpoonacularRecipeSearchParams } from '../Spoonacular/Recipe/SpoonacularRecipeSearchParams';

export type RecipeSearchParams = Omit<
  SpoonacularRecipeSearchParams,
  'offset' | 'number' | 'sort' | 'sortDirection' | 'cuisine' | 'diet'
> &
  Pageable & {
    dishTypes?: DishType[];
    cuisine?: CuisinesType[];
    diet?: DietsType[];
    seasons?: SeasonType[];
    minProteinPercent?: number;
    maxProteinPercent?: number;
    minFatPercent?: number;
    maxFatPercent?: number;
    minCarbsPercent?: number;
    maxCarbsPercent?: number;
    sampleSize?: number;
    excludedIds?: string[];
    minReadyTime?: number;
    maxReadyTime?: number;
  };

/** https://spoonacular.com/food-api/docs#Meal-Types **/
export const DishList = [
  'breakfast',
  'midMorning',
  'preWorkout',
  'postWorkout',
  'lunch',
  'snack',
  'dinner',
  'lateNight',
  'main_course',
  'side_dish',
  'dessert',
  'appetizer',
  'salad',
  // 'bread',
  'soup',
  'sauce',
  // 'marinade',
  'fingerfood',
] as const;

/** https://spoonacular.com/food-api/docs#Cuisines **/
export const CuisinesList = [
  'african',
  'american',
  // 'british',
  // 'cajun',
  // 'caribbean',
  'chinese',
  // 'eastern_european',
  'european',
  'french',
  // 'german',
  'greek',
  'indian',
  'irish',
  'italian',
  'japanese',
  // 'jewish',
  'korean',
  // 'latin_american',
  'mediterranean',
  'mexican',
  'middle_eastern',
  // 'nordic',
  'southern',
  'spanish',
  'thai',
  'vietnamese',
] as const;

export const SeasonList = ['spring', 'summer', 'autumn', 'winter'] as const;

/** https://spoonacular.com/food-api/docs#Diets **/
export const DietsList = [
  'vegan',
  'vegetarian',
  'pescetarian',
  'gluten_free',
  'dairy_free',
  'lacto_ovo_vegetarian',
  'paleolithic',
  // 'primal',
  // 'ketogenic',
  // 'whole_30',
  // 'gaps',
  // 'gaps_full',
  // 'gaps_3',
  // 'gaps_4',
  // 'gaps_5',
  // 'gaps_6',
] as const;

export const ExcludingDiets: { [key: string]: string[] } = {
  all: [
    'vegan',
    'vegetarian',
    'whole_30',
    'pescetarian',
    'paleolithic',
    'primal',
    'ketogenic',
    'lacto_ovo_vegetarian',
    'gluten_free',
    'dairy_free',
  ],
  vegan: ['all', 'vegetarian', 'whole_30', 'pescetarian', 'paleolithic', 'primal', 'lacto_ovo_vegetarian'],
  vegetarian: ['all', 'vegan', 'paleolithic', 'primal', 'whole_30', 'pescetarian'],
  primal: ['all', 'vegan', 'vegetarian', 'paleolithic', 'whole_30', 'ketogenic'],
  pescetarian: ['all', 'vegan', 'whole_30', 'paleolithic', 'vegetarian', 'primal'],
  paleolithic: ['all', 'vegan', 'vegetarian', 'whole_30', 'ketogenic', 'primal', 'pescetarian'],
  whole_30: ['all', 'vegan', 'vegetarian', 'pescetarian', 'ketogenic', 'paleolithic', 'primal', 'lacto_ovo_vegetarian'],
  ketogenic: ['all', 'whole_30', 'paleolithic', 'primal'],
  lacto_ovo_vegetarian: ['all', 'whole_30', 'vegan'],
  gluten_free: ['all'],
  dairy_free: ['all'],
};

export type DishType = typeof DishList[number];
export type CuisinesType = typeof CuisinesList[number];
export type DietsType = typeof DietsList[number];
export type SeasonType = typeof SeasonList[number];
